import Axios from "axios";

console.log('llmapi ', process.env.REACT_APP_ENV);


// Environment-aware API configuration matching main API helper
const getApiBaseUrl = (): string => {
  // Check if we're in production (same logic as api.ts)
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    // Production/Staging: Use relative URLs (handled by nginx/load balancer)
    return '/api/';
  }
  
  // Localhost development: Direct connection to backend
  return 'http://localhost:8080/api/';
};

const API_BASE_URL = getApiBaseUrl();

console.log('LLM API Configuration:', {
  baseURL: API_BASE_URL,
  environment: process.env.NODE_ENV
});

const llmAxiosInstance = Axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
  withCredentials: true, // Set to false for local testing
  timeout: 60000 // Increase to 60 second timeout for slower connections
});

// Add debugging interceptors
llmAxiosInstance.interceptors.request.use(request => {
  console.log('Starting Request:', {
    url: request.url,
    method: request.method,
    data: request.data,
    headers: request.headers
  });
  
  // Add JWT token to Authorization header if available
  const token = localStorage.getItem('auth_token');
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
    console.log('🔐 [LLM API] Added Bearer token to request');
  } else {
    console.warn('⚠️ [LLM API] No auth token found in localStorage');
  }
  
  return request;
});

llmAxiosInstance.interceptors.response.use(response => {
  console.log('Response:', {
    status: response.status,
    data: response.data,
    headers: response.headers
  });
  return response;
}, error => {
  console.log('Response Error:', {
    message: error.message,
    response: error.response?.data,
    status: error.response?.status
  });
  return Promise.reject(error);
});

export default llmAxiosInstance;
